import BaseAction from './BaseAction.js';

class UpdateTrackMuteAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({track, mute}) {
        if (track) {
            track.mute(mute);
        }
    }
}

export default UpdateTrackMuteAction;
